export interface AuthenticationMethod {
  id: string;
  enabled: boolean;
  name: string;
  description?: string;
  redirectUrl?: string;
  rotatingRedirectUrl?: string;
  rotationMin?: number;
  rotationMax?: number;
  type: AuthenticationMethodType;
  priorityOrder: number;
}

export enum AuthenticationMethodType {
  MTLS = 'MTLS',
  SITHS_EID_SAME_DEVICE = 'SITHS_EID_SAME_DEVICE',
  SITHS_EID_OTHER_DEVICE = 'SITHS_EID_OTHER_DEVICE',
  BANK_ID_OTHER_DEVICE = 'BANK_ID_OTHER_DEVICE',
  BANK_ID_SAME_DEVICE = 'BANK_ID_SAME_DEVICE',
  FREJA_EID_OTHER_DEVICE = 'FREJA_EID_OTHER_DEVICE',
  FREJA_EID_SAME_DEVICE = 'FREJA_EID_SAME_DEVICE',
  FREJA_EID_ORG_OTHER_DEVICE = 'FREJA_EID_ORG_OTHER_DEVICE',
  FREJA_EID_ORG_SAME_DEVICE = 'FREJA_EID_ORG_SAME_DEVICE',
  TOTP = 'TOTP',
  EIDAS = 'EIDAS'
}
